module.exports = __webpack_public_path__ + "static/diamond-desc-bf982a39b39db56fa48ecba5cbd4ba5b.webp";